<template>
  <span
    class="
      inline-block
      bg-slate-800
      text-white text-xs
      font-semibold
      ml-2
      px-2.5
      py-0.5
      rounded
    "
  >
    <slot></slot>
  </span>
</template>